'use client';

import { cn } from '@ngg/storefront-utils';
import { Variant } from '@ts/variant';
import { PackageIcon } from '@ui/icons';
import { locale } from '@utils/config';
import useCart from '@utils/hooks/cart/useCart';
import { ComponentProps } from 'react';

export const FREE_SHIPPING_THRESHOLD = 495;

export default function FreeShippingMessage({
  text,
  variant,
  className,
}: ComponentProps<'section'> & {
  text?: string;
  variant?: Variant;
}) {
  const cart = useCart(locale);
  if (!variant) return null;
  const total = cart.data?.cart?.totalGrossAmount;
  if ((total ?? 0) + variant.price > FREE_SHIPPING_THRESHOLD && text) {
    return (
      <section
        className={cn(
          'flex items-center justify-center gap-2 bg-beige p-4 font-sans text-sm',
          className,
        )}>
        <PackageIcon />
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </section>
    );
  }
  return null;
}
